// 全屏的插件
// import screenfull from 'screenfull';

export const store = {
	// 当前store的 id 标识
	name: 'LayoutStore',
	// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
	function: () => {
		// 控制全屏
		const triggerScreen = ref(false);
		const TRIGGER_FULL_SCREEN = (isFullscreen: boolean): void => {
			triggerScreen.value = isFullscreen;
		};

		return {
			// 控制全屏
			triggerScreen,
			TRIGGER_FULL_SCREEN
		};
	}
};
